<template>
  <b-row class="slider-input mt-1 slider-label-fix">
    <b-col md="6" sm="12" class="d-flex align-items-center w-100">
      <div
        class="slider-input__slider-container w-100"
        :disabled="disabled"
        :ref="'sliderRef'"
      />
    </b-col>
    <b-col md="6" sm="12" class="mt-4 mt-md-0">
      <b-form-input
        v-if="!sliderNumberInputHidden"
        :style="`width: ${inputWidth}`"
        class="slider-input__number-input text-center"
        type="text"
        inputmode="numericss"
        :disabled="disabled || isSetToMin"
        :value="visibleValue"
        @input="onInput"
        @focus="onFocus"
        @blur="onBlur"
        @change="onChange"
      />
    </b-col>
    <b-col cols="6" v-if="isLabels">
      <b-row class="">
        <b-col
          cols="6"
          class="text-left v3_color_black_knight "
        >
          {{ variable.min_label }}
        </b-col>
        <b-col
          cols="6"
          class="text-right v3_color_black_knight "
        >
          {{ variable.max_label }}
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import noUiSlider from 'nouislider';

export default {
  name: 'SliderInput',
  props: {
    initialValue: {
      //validator: (prop) => typeof prop === 'number' || (typeof prop === 'number' && !Number.isInteger(prop)) || prop === null,
      //validator: (prop) => typeof prop === 'number' || prop === null,
    },
    disabled: Boolean,
    variable: Object,
    isSetToMin: {
      type: Boolean,
      default: false,
    },
    isUnknown: {
      type: Boolean,
      default: false,
    },
    isDeclined: {
      type: Boolean,
      default: false,
    },
    sliderNumberInputHidden: {
      type: Boolean,
      default: false,
    }
  },
  data: function () {
    return {
      value: this.initialValue,
      isFocused: false,
    };
  },
  mounted: function () {
    this.initSlider();
  },
  computed: {
    step: function () {
      return this.variable.step ? parseFloat(this.variable.step) : 1;
    },
    min: function () {
      return this.variable.min ? this.variable.min : 0;
    },
    max: function () {
      return this.variable.max ? parseFloat(this.variable.max) : 1;
    },
    inputWidth: function () {
      const width = 60 + this.valueWithPrefixAndSuffix.toString().length * 9;
      return `${width}px`;
    },
    isLabels: function () {
      return !!(this.variable.min_label || this.variable.max_label);
    },
    numberValue: function () {
      return this.isUnknown ? 0 : this.value;
    },
    formattedValue: function () {
      const nf = new Intl.NumberFormat('en-US');
      return nf.format(this.numberValue);
    },
    valueWithPrefixAndSuffix: function () {
      return `${this.variable.prefix || ''}${this.formattedValue}${
        this.variable.suffix || ''
      }`;
    },
    visibleValue: function () {
      return this.isFocused
        ? this.formattedValue
        : this.valueWithPrefixAndSuffix;
    },
  },
  methods: {
    initSlider: function () {
      // initialize slider
      if (this.$refs.sliderRef) {
        noUiSlider.create(this.$refs.sliderRef, {
          start: this.numberValue ? this.numberValue : 0,
          connect: [true, false],
          step: this.step,
          range: {
            min: [this.min],
            max: [this.max],
          },
        });
        // handle slider updates
        this.$refs.sliderRef.noUiSlider.on('set', (values) => {
          if (this.disabled || (this.isDeclined && values[0] <= this.min)) {
            return;
          }
          //this.$emit('set-value', parseInt(values[0]));
          this.$emit('set-value', values[0]);
        });
        this.$refs.sliderRef.noUiSlider.on('update', (values) => {
          if (this.isUnknown) return;
          //this.value = parseInt(values[0]);
          this.value = values[0];
        });
      }
    },
    updateSlider: function () {
      this.$nextTick(() => {
        if (this.$refs.sliderRef) {
          const parsedMin = parseFloat(this.min);
          const parsedMax = parseFloat(this.max);

          this.$refs.sliderRef.noUiSlider.updateOptions({
            start: this.numberValue || 0,
            step: this.step,
            range: {
              min: [parsedMin],
              max: [parsedMax],
            },
          });
        }
      });
    },
    onFocus: function (event) {
      event.target.select();
      this.isFocused = true;
    },
    onBlur: function () {
      this.isFocused = false;
      this.setSliderValue();
    },
    onInput: function (value) {
      /* this.value = value || 0; */
      this.value = (value.toString().replace(/,/gi, '')) || 0;
    },
    onChange: function () {
      this.setSliderValue();
    },
    setSliderValue: function () {
      this.$refs.sliderRef &&
        this.$refs.sliderRef.noUiSlider.set([this.numberValue]);
    },
  },
  watch: {
    isSetToMin: function (newVal, prevVal) {
      if (newVal && !prevVal) {
        this.onInput(this.min);
        this.setSliderValue();
      }
    },
    isUnknown: function () {
      !this.isDeclined &&
        this.$refs.sliderRef &&
        this.$refs.sliderRef.noUiSlider.set([this.numberValue]);
    },
    isDeclined: function (newVal, prevVal) {
      if (newVal && !prevVal) {
        this.onInput(this.min);
        this.setSliderValue();
      }
    },
    step: function () {
      this.updateSlider();
    },
    min: function () {
      this.updateSlider();
    },
    max: function () {
      this.updateSlider();
    },
  },
};
</script>

<style lang="scss">
@import '../../../../sass/variables_mixins';
.slider-input__number-input {
  min-width: 65px;
  height: 35px;
  border-radius: 4px;
  border: 1px solid $phairify_v2_color_primary_teal;
  color: $phairify_v2_color_primary_teal;
  opacity: 1;
  //hide increment/decrement for input type number
  // Firefox
  -moz-appearance: textfield;
  //Chrome, Safari, Edge, Opera
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}
.slider-input__slider-container {
  background-color: $phairify_v2_color_light_gray;
  height: 20px;
  .noUi-connect {
    background-color: $phairify_v2_color_primary_teal !important;
  }
  .noUi-handle {
    border-radius: 50%;
    border: none;
    width: 30px;
    height: 30px;
    &:after,
    &:before {
      display: none;
    }
    .noUi-touch-area {
      border-radius: 50%;
      background: $phairify_v2_color_white 0 0 no-repeat padding-box;
      box-shadow: 0 1px 4px $phairify_v2_color_4D;
      opacity: 1;
    }
  }
}
@media screen and (max-width: 768px) {
  .slider-label-fix div:nth-child(2){
   order: 3;
  }
  .slider-label-fix > div:nth-child(3) {
    order: 2;
    margin-top: 10px;
    flex: 100%;
    max-width: 100%;
}
}
</style>
